const recaptchaSiteKey = '6LfZRJseAAAAACOQyAY2r75hi72Vs3CCfJfU1t0Q';
let recaptchaPromise;
let recaptchaScript;

const loadRecaptcha = () => {
	if (window.grecaptcha) {
		return Promise.resolve(window.grecaptcha);
	}

	if (!recaptchaPromise) {
		recaptchaPromise = new Promise((resolve, reject) => {
			const script = document.createElement('script');
			recaptchaScript = script;

			script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
			script.async = true;
			script.defer = true;
			script.onload = () => resolve(window.grecaptcha);
			script.onerror = () => {
				script.remove();
				recaptchaPromise = undefined;
				reject(new Error('reCAPTCHA script failed'));
			};

			document.head.appendChild(script);
		});
	}

	return recaptchaPromise;
};

export const getRecaptchaToken = () => {
	if (wp_data.recaptchaEnabled === false) return Promise.resolve('');

	let timeout;
	return new Promise((resolve, reject) => {
		timeout = setTimeout(() => reject(new Error('reCAPTCHA timed out')), 10000);
		loadRecaptcha().then((recaptcha) => {
			if (!recaptcha) throw new Error('reCAPTCHA unavailable');
			recaptcha.ready(() => {
				try {
					Promise.resolve(recaptcha.execute(recaptchaSiteKey, { action: 'submit' }))
						.then((token) => {
							if (typeof token !== 'string' || !token.trim()) throw new Error('reCAPTCHA token missing');
							resolve(token);
						}).catch(reject);
				} catch (error) { reject(error); }
			});
		}).catch(reject);
	}).catch((error) => {
		if (!window.grecaptcha) {
			recaptchaScript?.remove();
			recaptchaPromise = undefined;
		}
		throw error;
	}).finally(() => clearTimeout(timeout));
};
